import { DocumentNode, gql } from "@apollo/client";

class PreBillService {
  public static guestValidation = (): DocumentNode => gql`
    mutation GuestValidation($token: String!, $input: GuestValidationInput!) {
      guestValidation(token: $token, input: $input)
    }
  `;

  public static getOrderEstimate = (): DocumentNode => gql`
    query GetOrderEstimate($token: String!) {
      getOrderEstimate(token: $token) {
        patient {
          firstName
          uid
        }
        testType
        channel
        insuranceCompanyName
        insuranceEstimateDate
        totalInsuranceCost
        totalInsuranceCopay
        totalPrePayAmountProposed
        tokenExpireDate
        oonAverageOopMin
        oonAverageOopMax
        totalInsuranceRemainingDeductible
        innPatientResponsibilityValues {
          appliedDeductible
          estimatedOopMaxCost
          estimatedOopMinCost
        }
      }
    }
  `;

  public static getSetupIntent = (): DocumentNode => gql`
    query GetSetupIntent($token: String!) {
      getSetupIntent(token: $token) {
        customer
        client_secret
      }
    }
  `;

  public static sendPaymentChoice = (): DocumentNode => gql`
    mutation SendPaymentChoice(
      $token: String!
      $input: SendPaymentChoiceInput!
    ) {
      sendPaymentChoice(token: $token, input: $input)
    }
  `;

  public static sendSurveyAnswer = (): DocumentNode => gql`
    mutation SendSurveyAnswer($token: String!, $input: SendSurveyAnswerInput!) {
      sendSurveyAnswer(token: $token, input: $input) {
        message
      }
    }
  `;

  public static listActiveOrdersForPatient = (): DocumentNode => gql`
    query ListActiveOrdersForPatient {
      listActiveOrdersForPatient {
        activeOrders {
          tokenizedLink
          lastOrderSeen
          tokenExpireDate
          testTypeInformation {
            testType
            description
          }
        }
      }
    }
  `;
}

export default PreBillService;
